// @ts-nocheck
import { AbstractControl } from '@angular/forms';
import { ReplayControlValueChanges } from '@libs/rxjs/replay-control-value-changes';
import { isNil, isNumber } from 'lodash-es';


export const convertPhoneToDb = (
    phoneValue: string,
    phoneCode: string,
): string => {
    return (phoneCode + phoneValue).padStart(phoneValue.length + 3, '0');
};


export const nullOrUndefined = (value: unknown): boolean =>
    value === undefined || value === null;

export const minDateDependency = (
    // @ts-ignore
    self,
    controlMaster: AbstractControl,
    controlSlave: AbstractControl,
) => {
    if (
        !controlMaster ||
        !controlSlave ||
        !self.hasOwnProperty('minDependencyDate')
    ) {
        return false;
    }

    const dateControlChanges$ = new ReplayControlValueChanges(controlMaster);
    dateControlChanges$
        .subscribe((value: Date) => {
            if (value) {
                controlSlave.reset(
                    value?.getTime() > controlSlave?.value?.getTime()
                        ? null
                        : controlSlave?.value,
                );
            }
            self.minDependencyDate = value ? value : null;
        });
};

export const emptyFunction = () => {
};

export const parseNumber: (value: string) => number | null = (value: string) => {
    if (!isNil(value) && isNumber(Number(value))) {
        return Number(value);
    }

    return null;
};
